import React, { createContext, useCallback, useEffect, useState } from 'react';
import api from '../api/kiteApi';

export const AuthContext = createContext(null);
const LEGACY_TOKEN_STORAGE_KEY = 'KITE_ACCESS_TOKEN';

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecking, setAuthChecking] = useState(true);

  const refreshSession = useCallback(async () => {
    setAuthChecking(true);
    try {
      const response = await api.get('/auth/session');
      setIsAuthenticated(Boolean(response.data?.authenticated));
      return Boolean(response.data?.authenticated);
    } catch (error) {
      setIsAuthenticated(false);
      return false;
    } finally {
      setAuthChecking(false);
    }
  }, []);

  useEffect(() => {
    localStorage.removeItem(LEGACY_TOKEN_STORAGE_KEY);
    refreshSession();
  }, [refreshSession]);

  const logoutReal = async () => {
    // confirm before logging out
    if (!window.confirm('Really want to logout?')) return;
    setIsAuthenticated(false);
    try {
      const response = await api.post('/auth/logout');
      window.location.href = response.data?.redirect_to || '/real/login';
    } catch (error) {
      window.location.href = '/real/login';
    }
  };

  return (
    <AuthContext.Provider
      value={{
        authChecking,
        isAuthenticated,
        logoutReal,
        refreshSession,
        setIsAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
